export default "__VITE_ASSET__1ab7ef61__"